import React from "react";
import { award1, award2, award3, award4 } from "..";
const awardData = [
  {
    id: 0,
    ids: 'img1',
    award_img: award1,
    award_title1: "Recognized for Threat",
    award_title2: "Neutralization",
  },
  {
    id: 1,
    ids: 'img2',
    award_img: award2,
    award_title1: "Excellence in Continuous",
    award_title2: "Monitoring",
  },
  {
    id: 2,
    ids: 'img3',
    award_img: award3,
    award_title1: "24/7 Expert-Led",
    award_title2: "Support",
  },
  {
    id: 3,
    ids: 'img4',
    award_img: award4,
    award_title1: "Real-Time Risk",
    award_title2: "Intelligence",
  },
];
function AwardBox() {
  return (
    <div className="row">
      {awardData.map((items, index) => (
        <div className="col-md-3" key={index}>
          <div className="awardBox">
            <div className="awardImgWrap">
              <img src={items.award_img} alt={items.award_title1} className="img-fluid" id={items.ids}/>
            </div>
            <div className="awardNameWrap">
              <p>{items.award_title1}</p>
              <p>{items.award_title2}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AwardBox;
